<template>
  <div class="sidebar-wrapper" :class="{ 'sidebar-expanded': isExpanded }">
    <div class="toggle-btn" @click="toggleSidebar">
      <i :class="isExpanded ? 'icofont-rounded-left' : 'icofont-rounded-right'"></i>
    </div>

    <router-link to="/dashboard/organization/home" class="sidebar-link">
      <i class="icofont-home"></i>
      <span v-show="isExpanded">Home</span>
    </router-link>

    <router-link to="/dashboard/organization/user-upload" class="sidebar-link">
      <i class="icofont-upload-alt"></i>
      <span v-show="isExpanded">Bulk Upload</span>
    </router-link>

    <router-link to="/dashboard/organization/org-users" class="sidebar-link">
      <i class="icofont-users-alt-5"></i>
      <span v-show="isExpanded">Team</span>
    </router-link>

    <router-link to="/dashboard/organization/profile" class="sidebar-link">
      <i class="icofont-user"></i>
      <span v-show="isExpanded">Profile</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'OrganizationDashboardSidebar',
  data() {
    return {
      isExpanded: true,
      isMobile: false
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    // Emit initial state to parent component
    this.$emit('sidebar-toggle', this.isExpanded);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    toggleSidebar() {
      this.isExpanded = !this.isExpanded;
      this.$emit('sidebar-toggle', this.isExpanded);
    },
    checkMobile() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;
      
      // Auto-collapse when switching to mobile
      if (this.isMobile && !wasMobile) {
        this.isExpanded = false;
        this.$emit('sidebar-toggle', this.isExpanded);
      }
      // Auto-expand when switching to desktop (optional)
      else if (!this.isMobile && wasMobile) {
        this.isExpanded = true;
        this.$emit('sidebar-toggle', this.isExpanded);
      }
    }
  }
};
</script>

<style scoped>
.sidebar-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 100px;
  height: 100%;
  background-color: #2d7a4e;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  transition: width 0.3s ease;
  z-index: 998;
}

.sidebar-wrapper.sidebar-expanded {
  width: 200px;
  align-items: flex-start;
}

.toggle-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  margin-bottom: 20px;
  border-radius: 4px;
  transition: background 0.2s;
}

.toggle-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.toggle-btn i {
  font-size: 20px;
}

.sidebar-expanded .toggle-btn {
  align-self: flex-end;
  margin-right: 15px;
}

.sidebar-link {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: all 0.2s;
  position: relative;
}

.sidebar-expanded .sidebar-link {
  justify-content: flex-start;
  padding-left: 20px;
}

.sidebar-link i {
  font-size: 24px;
  min-width: 24px;
}

.sidebar-link span {
  margin-left: 15px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
}

.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.sidebar-link.router-link-active {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.sidebar-link.router-link-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: white;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 60px !important;
  }
  
  .sidebar-wrapper.sidebar-expanded {
    width: 180px !important;
  }
  
  .sidebar-link {
    height: 55px !important;
  }
  
  .sidebar-link i {
    font-size: 22px !important;
  }
  
  .sidebar-link span {
    font-size: 15px !important;
  }
}

@media (max-width: 576px) {
  .sidebar-wrapper {
    width: 60px !important;
  }
  
  .sidebar-wrapper.sidebar-expanded {
    width: 160px !important;
  }
  
  .sidebar-link {
    height: 50px !important;
  }
  
  .sidebar-link i {
    font-size: 20px !important;
  }
  
  .sidebar-link span {
    font-size: 14px !important;
  }
}
</style>